import { isValid } from "@al/aku-lc-helpers";
export var isInputOrSelectEvent = function (event, stopPropagation) {
    var _a;
    if (stopPropagation === void 0) { stopPropagation = true; }
    if (event === null || event === void 0 ? void 0 : event.target) {
        if (isValid(event.target.value) || isValid(event.target.checked)) {
            return true;
        }
        if (event.target.tagName &&
            event.target.tagName !== "INPUT" &&
            event.target.tagName !== "TEXTAREA" &&
            event.target.tagName !== "SELECT") {
            return false;
        }
        if (stopPropagation)
            (_a = event.stopPropagation) === null || _a === void 0 ? void 0 : _a.call(event);
        return true;
    }
    return false;
};
export var getValuesFromEvent = function (args) {
    return args.map(function (event) {
        if (event === null || event === void 0 ? void 0 : event.target) {
            if (isValid(event.target.value)) {
                return event.target.value;
            }
            if (isValid(event.target.checked)) {
                return event.target.checked;
            }
            return;
        }
        return event;
    });
};
